<script>
import SignupForm from '@/components/SignupForm.vue'
import LangSwitcher from '@/components/LangSwitcher.vue'

export default {
    name: 'Signup',
    components: { SignupForm, LangSwitcher },
    data() {
        return { step: 0 }
    },
    computed: {
        signupFormWidth() {
            if (this.step == 1) {
                return { lg: 8, offsetLg: 2 }
            }
            return { lg: 6, offsetLg: 3, xl: 4, offsetXl: 4 }
        },
    },
    methods: {
        onSuccess() {
            // Sends the racer back where they were trying to go (a board's Join Tournament
            // button, a reservation, a voucher, etc.) whenever this signup was reached via a
            // loginRequired redirect; falls back to the original default landing spot when
            // there's nowhere specific to return to (e.g. a plain, unprompted signup).
            this.$router.push(this.$route.query.redirect || { name: 'reservations' })
        },
    },
    async mounted() {
        if (this.$route.query?.redirect?.match(/reservations/gi)) {
            this.addMessage('info', 'Sign up or Log in to view sim availability')
        } else if (this.$route.query?.redirect?.match(/vouchers/gi)) {
            this.addMessage('info', 'Sign up or Log in to purchase a voucher')
        } else if (this.$route.query?.redirect?.match(/subscription/gi)) {
            this.addMessage('info', 'Sign up or Log in to create a subscription')
        }
    },
}
</script>

<template>
    <b-container class="pt-5">
        <b-row>
            <b-col v-bind="signupFormWidth">
                <b-card>
                    <template v-slot:header>
                        <div class="d-flex align-items-center justify-content-between">
                            <span>Sign Up</span>
                            <small><lang-switcher dark /></small>
                        </div>
                    </template>
                    <messages />
                    <signup-form @step="(newStep) => step = newStep" />
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
